import { supabaseClient } from "@/lib/supabase";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@patient-watch/ui/sonner";
import { useToastCopy } from "@/features/i18n/toastCopy";
import { distinctDiaryLabelsQueryKey } from "./selectDistinctDiaryLabels";
import { diaryLabelsQueryKey } from "./selectDiaryLabels";

export interface DeleteDiaryLabelParams {
    label_id: string;
}

export async function deleteDiaryLabel({ label_id }: DeleteDiaryLabelParams): Promise<void> {
    const { error } = await supabaseClient.from("diary_labels").delete().eq("label_id", label_id);

    if (error) throw error;
}

export function useDeleteDiaryLabel() {
    const queryClient = useQueryClient();
    const toastCopy = useToastCopy();

    return useMutation({
        mutationFn: deleteDiaryLabel,
        onError: (error: Error) => {
            toast.error(error.message);
        },
        onSuccess: () => {
            toast.success(toastCopy.labelDeleted);
            void queryClient.invalidateQueries({ queryKey: distinctDiaryLabelsQueryKey });
            void queryClient.invalidateQueries({ queryKey: diaryLabelsQueryKey });
        },
    });
}
